import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

export default function ( { $config } ) {
  Vue.use( VueLazyload, {
    silent: $config.RELEASE_STAGE === 'production' // Print errors if not in production
  } )
}
